import { render, staticRenderFns } from "./InfinateLoadingBase.vue?vue&type=template&id=a0d5dd42"
import script from "./InfinateLoadingBase.vue?vue&type=script&lang=js"
export * from "./InfinateLoadingBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports